// extracted by mini-css-extract-plugin
module.exports = {"header":"_15760","back":"_4499","shareIcon":"_11501"};